// Constants TypeScript files should be AUTO-GENERATED by the Typewriter Visual Studio plugin. Do not modify this file.
export default class PermissionNames {
    public static readonly CONTROLSREAD: string = 'controls.read';
    public static readonly CONTROLSWRITE: string = 'controls.write';
}
